<template>
	<div class="data-apply">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/datacenter/dishes' }">菜品</el-breadcrumb-item>
			<el-breadcrumb-item>编辑菜品适用信息</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row style="margin-top:15px">
			<el-col style="width:200px;border: 1px solid #cccccc;border-radius: 6px;">
				<el-image
				 style="width: 200px; height: 125px"
				 :src="dishesExt.dishesImageUrl"
				 fit="cover"
				></el-image>
			</el-col>
			<el-col
			 :span="16"
			 style="padding-left:30px;text-align:left"
			>
				<span>菜品名称：{{dishesExt.dishesName}}</span>
				<el-divider></el-divider>
				<span style="display: block;margin-bottom: 15px;text-align:left;">季节适应性</span>
				<div style="margin-left:6%">
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">春季</span>
							<span> 3月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="springMarch"
							 v-model="springMarch"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'springMarch',3,march.id)"
							 :marks="marks"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">4月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="springApril"
							 v-model="springApril"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'springApril',4,april.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">5月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="springMay"
							 v-model="springMay"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'springMay',5,may.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">夏季</span>
							<span> 6月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="summerJune"
							 v-model="summerJune"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'summerJune',6,june.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">7月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="summerJuly"
							 v-model="summerJuly"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'summerJuly',7,july.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">8月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="summerAug"
							 v-model="summerAug"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'summerAug',8,aug.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">秋季</span>
							<span> 9月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="autumnSep"
							 v-model="autumnSep"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'autumnSep',9,sep.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">10月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="autumnOct"
							 v-model="autumnOct"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'autumnOct',10,oct.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">11月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="autumnNove"
							 v-model="autumnNove"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'autumnNove',11,nove.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">冬季</span>
							<span> 12月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="winterDec"
							 v-model="winterDec"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'winterDec',12,dec.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">1月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="winterJan"
							 v-model="winterJan"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'winterJan',1,jan.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">2月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="winterFeb"
							 v-model="winterFeb"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'winterFeb',2,feb.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
				</div>
				<apply-area
				 :data="dishesExt.area"
				 @areaChange="areaChange"
				></apply-area>
				<el-divider></el-divider>
				<pick-tags label="适宜人群" labelWidth="60px" :dynamicTags="dishesExt.crowd" :tags="crowdList" :required="false"></pick-tags>
				<el-divider></el-divider>
				<pick-tags label="功效作用" labelWidth="60px" :dynamicTags="dishesExt.efficacy" :tags="efficacyList" :required="false"></pick-tags>
			</el-col>
		</el-row>
		<el-row style="position: fixed;bottom:3px;padding-left:35%">
			<el-button type="primary" @click="onSubmit">保存</el-button>
    	<el-button @click="cancle">取消</el-button>
		</el-row>
	</div>
</template>

<script>
import {fetchExtAreaGroupList} from '@/api/city'
import { fetchDictListByType } from '@/api/dict'
import { queryDishesDetail,updateExt } from '@/api/catering/dishes'
import ApplyArea from "../applyarea";
import PickTags from "@/components/PickTags/index";
export default {
  components: {
    ApplyArea,
    PickTags
  },
  data() {
    return {
      springMarch: 0,
      springApril: 0,
      springMay: 0,
      summerJune: 0,
      summerJuly: 0,
      summerAug: 0,
      autumnSep: 0,
      autumnOct: 0,
      autumnNove: 0,
      winterDec: 0,
      winterJan: 0,
      winterFeb: 0,
			march: {},
			april: {},
      may: {},
      june: {},
      july: {},
      aug: {},
      sep: {},
      oct: {},
      nove: {},
      dec: {},
      jan: {},
      feb: {},
      marks: {
        8: "不吃",
        22: "一月一次",
        36: "两周一次",
        50: "每周一次",
        64: "每周两次",
        78: {
          label: "每日一次",
          style: {
            width: "70px",
            textAlign: "right"
          }
        }
      },
			efficacyList:[],
			crowdList: [],
      dishesExt: {
				crowd: [],
				efficacy: [],
				area: {}
			}    
    };
  },
	created() {
		this.query(this.$route.query.uid);
	},
  methods: {
		query(id) {
			queryDishesDetail(id).then(response=>{
				let data = response.data;
				if(Object.keys(data.area).length > 0) {
					if(data.season.length > 0) {
						this.assemblySeason(data.season);
					}
				} else {
					this.fetchAreaList();
				}
				this.queryDictListByCode('efficacy');
				this.queryDictListByCode('crowd');
				this.dishesExt = data;
			})
		},
		fetchAreaList() {
			fetchExtAreaGroupList().then(response=>{
				this.dishesExt.area = response.data;
			})
		},
		onSubmit() {
			this.dishesExt.season = [];
			this.dishesExt.season.push(this.march);
			this.dishesExt.season.push(this.april);
			this.dishesExt.season.push(this.may);
			this.dishesExt.season.push(this.june);
			this.dishesExt.season.push(this.july);
			this.dishesExt.season.push(this.aug);
			this.dishesExt.season.push(this.sep);
			this.dishesExt.season.push(this.oct);
			this.dishesExt.season.push(this.nove);
			this.dishesExt.season.push(this.dec);
			this.dishesExt.season.push(this.jan);
			this.dishesExt.season.push(this.feb);
			if(!this.dishesExt.id) {
				Object.assign(this.dishesExt,{id: this.$route.query.uid})
			}
			console.log(this.dishesExt);
			// return;
			const loading = this.$loading({
				lock: true,
				text: '菜品适用信息保存中,请不要退出',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			updateExt(this.dishesExt).then(response=>{
				this.$message.success('菜品适用信息编辑成功');
				loading.close();
				this.cancle()
			})
		},
		cancle() {
			this.$router.push({name:'dishesList',path: '/datacenter/dishes',params: {page: this.$route.query.page}});
		},
    dragVal(nval, dom,month,id) {
      let color = null;
			let valueDictValue = null;
			let valueDictName = null;
      if (nval > 0 && nval <= 14) {
        color = "#919191";
				valueDictValue = 0;
				valueDictName = '不吃'
      } else if (nval > 14 && nval <= 28) {
        color = "#73d13d";
				valueDictValue = 1;
				valueDictName = '一月一次'
      } else if (nval > 28 && nval <= 42) {
        color = "#fcca00";
				valueDictValue = 2;
				valueDictName = '两周一次'
      } else if (nval > 42 && nval <= 56) {
        color = "#ff9502";
				valueDictValue = 3;
				valueDictName = '每周一次'
      } else if (nval > 56 && nval <= 70) {
        color = "#ff3d00";
				valueDictValue = 4;
				valueDictName = '每周两次'
      } else if (nval > 70) {
        color = "#cf1322";
				valueDictValue = 5;
				valueDictName = '每日一次'
      }
			// if(!id) {
			// 	id = null;
			// }
			let obj = {
					id: id,
					itemDictCode: "season",
					itemDictName: month + '月',
					itemDictValue: month,
					valueDictCode: "season_number",
					valueDictName: valueDictName,
					valueDictValue: valueDictValue,
			}
			if(month == 3) {
				this.march = obj;
			}
			if(month == 4) {
				this.april = obj;
			}
			if(month == 5) {
				this.may = obj;
			}
			if(month == 6) {
				this.june = obj;
			}
			if(month == 7) {
				this.july = obj;
			}
			if(month == 8) {
				this.aug = obj;
			}
			if(month == 9) {
				this.sep = obj;
			}
			if(month == 10) {
				this.oct = obj;
			}
			if(month == 11) {
				this.nove = obj;
			}
			if(month == 12) {
				this.dec = obj;
			}
			if(month == 1) {
				this.jan = obj;
			}
			if(month == 2) {
				this.feb = obj;
			}
			
      this.$refs[dom].$el.getElementsByClassName(
        "el-slider__bar"
      )[0].style.backgroundColor = color;
    },
    formatTooltip(val) {
      if (val > 0 && val <= 14) {
        return "不吃";
      } else if (val > 14 && val <= 28) {
        return "一月一次";
      } else if (val > 28 && val <= 42) {
        return "两周一次";
      } else if (val > 42 && val <= 56) {
        return "每周一次";
      } else if (val > 56 && val <= 70) {
        return "两周两次";
      } else if (val > 70) {
        return "每日一次";
      }
    },
		assemblySeason(data) {
			data.map(item=>{
				const month = item.itemDictValue;
				let feacy = item.valueDictValue == null? -1: item.valueDictValue;
				let dom = '';
				if(month==3) {
					dom = 'springMarch';
					this.springMarch = (feacy+1)*14
				}	
				if(month==4) {
					dom = 'springApril';
					this.springApril = (feacy+1)*14
				}	
				if(month==5) {
					dom = 'springMay';
					this.springMay = (feacy+1)*14
				}	
				if(month==6) {
					dom = 'summerJune';
					this.summerJune = (feacy+1)*14
				}	
				if(month==7) {
					dom = 'summerJuly';
					this.summerJuly = (feacy+1)*14
				}	
				if(month==8) {
					dom = 'summerAug';
					this.summerAug = (feacy+1)*14
				}	
				if(month==9) {
					dom = 'autumnSep';
					this.autumnSep = (feacy+1)*14
				}	
				if(month==10) {
					dom = 'autumnOct';
					this.autumnOct = (feacy+1)*14
				}	
				if(month==11) {
					dom = 'autumnNove';
					this.autumnNove = (feacy+1)*14
				}	
				if(month==12) {
					dom = 'winterDec';
					this.winterDec = (feacy+1)*14
				}	
				if(month==1) {
					dom = 'winterJan';
					this.winterJan = (feacy+1)*14
				}	
				if(month==2) {
					dom = 'winterFeb';
					this.winterFeb = (feacy+1)*14
				}				
				this.dragVal((feacy+1)*14,dom,month,item.id);
			})
		},
		queryDictListByCode(code) {
			fetchDictListByType(code).then(res=>{
				let data = res.data.map(item=>{
					let id = null;
					if(code == 'crowd') {
						if(this.dishesExt.crowd.length > 0) {
							this.dishesExt.crowd.map(c=>{
								if(item.value == c.itemDictValue) {
									id = c.id;
									c.name = item.name;
									c.index = item.index;
								}
							})
						}
					} else {
						if(this.dishesExt.efficacy.length > 0) {
							this.dishesExt.efficacy.map(c=>{
								if(item.value == c.itemDictValue) {
									id = c.id;
									c.name = item.name;
									c.index = item.index;
								}
							})
						}
					}
						return {id: id,name: item.name,itemDictCode: item.code,itemDictName:item.name,
										itemDictValue:item.value,valueDictCode:'suitable',valueDictName:'适宜',valueDictValue:1,index:item.index}
				})
				if(code == 'crowd') {
					this.crowdList = data;
				} else {
					this.efficacyList = data;
				}
			})
		},
    areaChange(nval,city) {
			if(nval == 1) {
				city.valueDictName = '常用'
			} else {
				city.valueDictName = '不常用'
			}
		}
  }
};
</script>

<style lang="scss" scoped>
.data-apply {
  margin-top: 15px;
  margin-left: 15px;
  padding-bottom: 30px;
  position: relative;
}
.seasons {
  width: 70px;
  line-height: 18px;
  // padding-left: 45px;
  // margin-right: 25px;
  text-align: right;
}
.slider-container {
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/dishes/dishesApply.vue